import { useAppDispatch, useAppSelector } from './state'
import { getPayments as getPaymentsAPI } from '../api/payments'
import { setPayments, setPaymentsIsLoading } from '../state/slices/payments_slice'
import { getResourceAuthorization } from '../state/selectors/resource_authorization'

export const usePayments = () => {
  const dispatch = useAppDispatch()
  const currentResourceAuthorization = useAppSelector(getResourceAuthorization)

  const getPayments = async () => {
    dispatch(setPaymentsIsLoading(true))

    if (!currentResourceAuthorization?.relationNumber) {
      dispatch(setPaymentsIsLoading(false))

      return
    }

    try {
      const result = await getPaymentsAPI(currentResourceAuthorization?.relationNumber)

      if (result.relation) {
        dispatch(setPayments(result.relation))
      }

      return true
    } catch (e) {
      return false
    } finally {

      dispatch(setPaymentsIsLoading(false))
    }
  }

  return {
    getPayments
  }
}

export default usePayments
